import React from "react";

export default function About() {
    return (
        <section
            id="sobre"
            data-testid="about-section"
            className="relative py-24 md:py-40 overflow-hidden"
        >
            <div className="absolute top-20 right-0 w-[500px] h-[500px] glow-yellow pointer-events-none" />

            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    {/* Text col */}
                    <div className="lg:col-span-7">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-12 bg-neon-yellow" />
                            <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                                ▸ Sobre o servidor
                            </span>
                        </div>
                        <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.9] tracking-tighter mb-8">
                            Nasceu na
                            <br />
                            <span className="text-stroke">rua,</span>{" "}
                            <span className="text-neon-yellow">cresceu</span>
                            <br />
                            no asfalto.
                        </h2>
                        <p className="text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed mb-6">
                            FORZA PILOTS é o playground definitivo pra quem
                            vive de pisar fundo. Aqui a sirene canta toda noite,
                            o tráfico de motor não dorme e a polícia tá sempre
                            no seu retrovisor.
                        </p>
                        <p className="text-base md:text-lg text-white/60 max-w-2xl leading-relaxed mb-10">
                            Mais que um servidor de FiveM, é um submundo de
                            corredores, foragidos e legends. Monta tua crew,
                            tunaza o carro e foge da lei — ou seja a lei.
                        </p>

                        <div className="flex flex-wrap gap-4">
                            {[
                                "PERSEGUIÇÕES DINÂMICAS",
                                "TUNNING REAL",
                                "ROUBOS PVP",
                                "ECONOMIA DO SUBMUNDO",
                            ].map((tag, i) => (
                                <span
                                    key={i}
                                    data-testid={`about-tag-${i}`}
                                    className="font-mono text-xs uppercase tracking-[0.2em] border border-white/20 px-4 py-2 text-white/80 hover:border-neon-yellow hover:text-neon-yellow transition-colors"
                                >
                                    #{tag}
                                </span>
                            ))}
                        </div>
                    </div>

                    {/* Image col - overlapping */}
                    <div className="lg:col-span-5 relative h-[500px] md:h-[600px]">
                        <div className="absolute top-0 right-0 w-[80%] h-[60%] border-4 border-neon-yellow overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1563741603582-adf5a8332a73?crop=entropy&cs=srgb&fm=jpg&q=85"
                                alt="Police chase"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="absolute bottom-0 left-0 w-[70%] h-[55%] border-4 border-white shadow-brutal-red overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1606512084153-189ffdc0f086?crop=entropy&cs=srgb&fm=jpg&q=85"
                                alt="Night street"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="absolute -bottom-6 -right-2 bg-neon-yellow text-black p-4 font-mono text-xs uppercase tracking-[0.2em] rotate-3">
                            // est. 2024
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
